import { clsx } from 'clsx'
import { type FC } from 'react'

import { Link } from 'base-ui'

import { type ProductPageKeyFact } from '../useProductPageKeyFacts'

interface ProductKeyFactProps {
  keyFact: ProductPageKeyFact
}

const ProductKeyFact: FC<ProductKeyFactProps> = ({ keyFact }) => {
  const { content, contentUrl, icon: IconComponent, title, type } = keyFact

  return (
    <li className="flex grow flex-row items-start text-s text-dark-primary-max tablet:max-w-[280px]">
      {IconComponent ? (
        <IconComponent className="mr-3 size-10 shrink-0 self-center fill-dark-primary-max" />
      ) : (
        <div className="mr-4 size-8 shrink-0" />
      )}
      <dl className="flex grow flex-col flex-wrap items-start gap-y-1 self-center tablet:gap-x-2">
        <dt className="font-medium">{title}</dt>
        <dd className="font-normal">
          {contentUrl ? (
            <Link
              className={clsx(type !== 'brand' && 'no-underline')}
              color="inherit"
              href={contentUrl}
            >
              {content}
            </Link>
          ) : (
            content
          )}
        </dd>
      </dl>
    </li>
  )
}

export { ProductKeyFact }
